import { useState } from "react"
import { Container, Grid, Typography, TextField, Button, Paper, Alert } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useNavigate } from "react-router-dom"
import { useApiService } from "../hooks/Api/useApiService"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import useError from "../hooks/Error/useError"

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  marginTop: theme.spacing(4),
  boxShadow: theme.shadows[3],
}))
const BusinessInfoForm = () => {
  const [form_data, setFormData] = useState(null)
  const [severity, setSeverity] = useState("error")
  const navigate = useNavigate()
  const { postData } = useApiService()
  const t = useTranslationSharie()
  const { Error: AlertError, error, success } = useError()

  const handleSubmit = () => {
    if (
      form_data &&
      form_data.address &&
      form_data.city &&
      form_data.country &&
      form_data.crn &&
      form_data.description &&
      form_data.email &&
      form_data.name &&
      form_data.phone &&
      form_data.email &&
      form_data.url
    ) {
      postData("business/postbusiness", {
        business: form_data,
        user_name: localStorage.getItem("user"),
      }).then((data) => {
        if (data.message == "Successful") {
          success("Business Successfuly Created!")
        } else {
          error(data.message)
        }
      })
      navigate("/buycredit", { state: { business: true } })
    } else {
      error("You Must Fill All Fields")
    }
  }
  return (
    <T>
      <Container maxWidth='md'>
        <StyledPaper>
          <Typography variant='h4' align='center' gutterBottom>
            Company Business Information
          </Typography>
          <Typography variant='subtitle1' align='center' color='textSecondary' gutterBottom>
            Please fill in the details below to help us know more about your company
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={t("Company Name")}
                variant='outlined'
                required
                onChange={(e) => setFormData({ ...form_data, name: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={t("Address")}
                variant='outlined'
                required
                multiline
                rows={2}
                onChange={(e) => setFormData({ ...form_data, address: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={t("City")}
                variant='outlined'
                required
                onChange={(e) => setFormData({ ...form_data, city: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={t("Country")}
                variant='outlined'
                required
                onChange={(e) => setFormData({ ...form_data, country: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={t("Contact Email")}
                variant='outlined'
                required
                type='email'
                onChange={(e) => setFormData({ ...form_data, email: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={t("Phone Number")}
                variant='outlined'
                required
                type='tel'
                onChange={(e) => setFormData({ ...form_data, phone: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={t("Company Description")}
                variant='outlined'
                required
                multiline
                rows={4}
                onChange={(e) => setFormData({ ...form_data, description: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={t("Website URL")}
                variant='outlined'
                type='url'
                onChange={(e) => setFormData({ ...form_data, url: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={t("CRN")}
                required
                variant='outlined'
                onChange={(e) => setFormData({ ...form_data, crn: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} align='center'>
              <Button onClick={handleSubmit} variant='contained' color='primary' size='large'>
                Submit
              </Button>
            </Grid>
          </Grid>
          <AlertError />
        </StyledPaper>
      </Container>
    </T>
  )
}

export default BusinessInfoForm
